// import { isEmpty } from 'lodash';

type BuildChartQueryFilterProps = {
    visualisationType?: string;
    splitter?: Record<string, string>;
    filter?: Record<string, string>;
};

export const BuildChartQueryFilter = (params: BuildChartQueryFilterProps): Record<string, string> => {
    // build here
    const { splitter, filter } = params;
    const combined = {
        ...splitter,
        ...filter,
    };

    return combined;
};

export const IsRunningInFEDEnv = (): boolean => {
    const { location } = window;
    const { hostname, port } = location;

    if ((hostname === 'localhost' && port.startsWith('300')) // localhost:300x
        || hostname.endsWith('netlify.app')
        || hostname.endsWith('luminary.space')
    ) {
        return true;
    }

    return false;
};
